import { render, staticRenderFns } from "./OfferCategoriesList.vue?vue&type=template&id=6487f123"
import script from "./OfferCategoriesList.vue?vue&type=script&lang=js"
export * from "./OfferCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports